










































































































































































































































import Vue from 'vue'
import CategoryPostBreadcrumbs from '@/components/common/CategoryPostBreadcrumbs.vue'
import VideoPlayer from '@/components/product/VideoPlayer.vue'
import Category from '@/models/Category'
import InstructorCard from '@/components/product/InstructorCard.vue'
import NewYorkPostQueue from '../NewYorkPostQueue.vue'
import { MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE } from '@/helper/constants'
import CategoryTreeNode, {
  CategoryTreeNodeType
} from '@/models/CategoryTreeNode'
import {
  findNextPostId,
  findPreviousPostId,
  getCurrentPostIndex
} from '@/helper/index'
import CommentList from '@/components/comments/CommentList.vue'
import { PostService } from '@/services'

export default Vue.extend({
  components: {
    CategoryPostBreadcrumbs,
    InstructorCard,
    NewYorkPostQueue,
    VideoPlayer,
    CommentList
  },
  props: {
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    activePost: {
      type: Object
    },
    category: {
      type: Object
    },
    videoOptions: {
      type: Object
    },
    playlist: {
      type: Array
    },
    disableActions: {
      type: Object
    },
    postCompletionButtonText: String,
    postMarkedAsCompleted: Boolean,
    lessonButton: Object,
    isAdmin: Boolean,
    categoryTree: Array,
    fetchingPost: Boolean,
    fetchingPostCompletionStatus: Boolean,
    disablePostCompletionButton: Boolean,
    completedPostIds: {
      type: Set,
      default: new Set()
    }
  },
  async mounted() {
    try {
      this.post = await PostService.findById(this.postId)
    } catch (error) {
      console.log("Something went wrong")
    }
    window.scrollTo(0, 0)
    document
      .querySelector('#read-more-post')
      ?.addEventListener('click', this.expandPostDescription)
  },
  metaInfo() {
    const meta = {}
    meta['link'] = [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css?family=Lato',
        vmid: 'newYorkFonts'
      }
    ]
    return meta
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    categoryId(): string {
      return this.$route.params.category_id
    },
    postId(): string {
      return this.$route.params.post_id
    },
    lessonSettings(): object {
      return this.product.customizations?.lessonSettings
    },
    templateId(): string {
      return this.$route.query.template_id
    },
    postDescription(): string {
      return this.activePost.description &&
        this.activePost.description.length > MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE
        ? this.derivePostDescription() +
            '.... ' +
            `<span class="text-blue-500 cursor-pointer" id="read-more-post">Read More</span>`
        : this.activePost.description
    },
    isExpandable(): boolean {
      return this.activePost.description.length > 5700 ? true : false
    },
    themeSettings(): object {
      return this.product.customizations?.lessonSettings?.themeSettings
    },
    sections(): object {
      return this.product.customizations?.lessonSettings?.sections
    },
    postCompletedIcon(): string {
      if (this.sections?.lessonBody?.button?.color) {
        return this.sections?.lessonBody?.button?.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return this.postMarkedAsCompleted
        ? '#2f855a'
        : this.disablePostCompletionButton || this.isAdmin
        ? '#6b7280'
        : '#ffffff'
    },
    navigationButtonColor(): string {
      if (this.sections?.lessonBody?.navigationButton?.color) {
        return this.sections.lessonBody.navigationButton.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return '#709BE0'
    },
    categoryNavIcon(): string {
      if (this.sections?.courseNavigation?.category?.color) {
        return this.sections.courseNavigation.category.color
      } else if (this.themeSettings?.secondaryStyle?.color) {
        return this.themeSettings?.secondaryStyle.color
      }
      return '#607179'
    },
    goBackIcon(): string {
      if (this.sections?.courseNavigation?.breadCrumb?.color) {
        return this.sections?.courseNavigation?.breadCrumb?.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return '#111827'
    },
    highlightBackground(): string {
      if (this.sections?.courseNavigation?.highlight?.backgroundColor) {
        return this.sections?.courseNavigation?.highlight?.backgroundColor
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle?.color
      }
      return '#709be0'
    },
    highlightColor(): string {
      if (this.sections?.courseNavigation?.highlight?.color) {
        return this.sections.courseNavigation.highlight.color
      }
      return '#ffffff'
    },
    parentCategoryTitle(): string {
      if (this.category.parentCategory) {
        const parentCategory = this.categoryTree.find(
          (node: CategoryTreeNode) => node.id === this.category.parentCategory
        )
        return parentCategory?.node.title
      }
      return null
    },
    markCompletedBtnCss() {
      if (this.disablePostCompletionButton || this.isAdmin) {
        return 'lessonPrimaryStyle lesson-body__btn bg-white text-gray-600 cursor-not-allowed'
      } else if (this.postMarkedAsCompleted) {
        return 'text-green-700'
      }
      return 'mark-as-post-completed lessonPrimaryStyle lesson-body__btn text-white'
    },
    availableCategoryTree(): object {
      return this.categoryTree.filter((node: any) => node.node.available)
    },
    availablePlayList(): Array<CategoryTreeNode> {
      return this.playlist.filter(
        (node: any) =>
          node.type === CategoryTreeNodeType.Post ||
          (node.type === CategoryTreeNodeType.Category && node.node.available)
      )
    },
    previousPostData(): object {
      return findPreviousPostId(
        this.availableCategoryTree,
        this.postId,
        this.category,
        this.availablePlayList
      )
    },
    nextPostData(): object {
      return findNextPostId(
        this.availableCategoryTree,
        this.postId,
        this.category,
        this.availablePlayList
      )
    },
    totalPost(): number {
      let parentCategory
      if (this.category.parentCategory) {
        parentCategory = this.availableCategoryTree.find(
          (node: CategoryTreeNode) => node.id === this.category.parentCategory
        )
      } else {
        parentCategory = this.availableCategoryTree.find(
          (node: CategoryTreeNode) => node.id === this.category.id
        )
      }
      return (
        parentCategory?.childs.reduce((acc, node: CategoryTreeNode) => {
          if (node.type === CategoryTreeNodeType.Category) {
            acc += node.childs.length
            return acc
          }
          return ++acc
        }, 0) || 0
      )
    },
    currentPostIndex(): number {
      return getCurrentPostIndex(this.postId, this.category, this.categoryTree)
    },
    previousCategory(): object {
      let id = this.categoryId
      if (this.category.parentCategory) {
        const parentCategory = this.availableCategoryTree.find(
          (node: CategoryTreeNode) => node.id === this.category.parentCategory
        )
        id = parentCategory?.id
      }
      const index = this.availableCategoryTree.findIndex(
        (node: CategoryTreeNode) => node.id === id
      )
      if (index === 0) {
        return null
      }
      const categories =
        this.availableCategoryTree[index - 1]?.childs?.filter(
          (node: any) =>
            node.type === CategoryTreeNodeType.Post ||
            (node.type === CategoryTreeNodeType.Category && node.node.available)
        ) || []
      if (categories[0]?.type === CategoryTreeNodeType.Category) {
        return {
          category: categories[0]?.id,
          post: categories[0]?.childs[0]?.id || null
        }
      }
      return {
        category: this.availableCategoryTree[index - 1]?.id,
        post: categories[0]?.id || null
      }
    },
    nextCategory(): object {
      let id = this.categoryId
      if (this.category.parentCategory) {
        const parentCategory = this.availableCategoryTree.find(
          (node: CategoryTreeNode) => node.id === this.category.parentCategory
        )
        id = parentCategory?.id
      }
      const index = this.availableCategoryTree.findIndex(
        (node: CategoryTreeNode) => node.id === id
      )
      if (index >= this.availableCategoryTree.length - 1) {
        return null
      }
      const categories =
        this.availableCategoryTree[index + 1]?.childs?.filter(
          (node: any) =>
            node.type === CategoryTreeNodeType.Post ||
            (node.type === CategoryTreeNodeType.Category && node.node.available)
        ) || []
      if (categories[0]?.type === CategoryTreeNodeType.Category) {
        return {
          category: categories[0]?.id,
          post: categories[0]?.childs[0]?.id || null
        }
      }
      return {
        category: this.availableCategoryTree[index + 1]?.id,
        post: categories[0]?.id || null
      }
    }
  },
  data() {
    return {
      parentCategory: null as Category,
      expandPost: false,
      readMorePost: null,
      showExpandIcon: false,
      expandPostData: false,
      post: {}
    }
  },
  methods: {
    derivePostDescription(): string {
      const descriptionBeforeAttachingReadmore = this.activePost.description
      const descriptionAfterAttachingReadmore = this.activePost.description.substring(0, MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE) // if we are having a Read more
      const restOfTheDescription = this.activePost.description.substring(MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE) // remaining part after descriptionAfterAttachingReadmore

      const listOfAllHtmlTagsInDescriptionBeforeAttachingReadmore = this.findSubstringInstances(descriptionAfterAttachingReadmore, /(<([^>]+)>)/ig)
      const alltagsWithParams = listOfAllHtmlTagsInDescriptionBeforeAttachingReadmore.filter(elem => elem.startsWith("<"))

      const numberOfOpeningTags = alltagsWithParams.filter(elem => elem.split('')[1] !== "/").length
      const numberOfClosingTags = alltagsWithParams.filter(elem => elem.split('')[1] === "/").length

      if (numberOfOpeningTags === numberOfClosingTags) {
        return descriptionAfterAttachingReadmore
      } else {
        const incompleteHtmlTags = []
        alltagsWithParams.forEach(element  => {
          const isAClosingTag = element.split('')[1] === "/"
          if (isAClosingTag === true) {
            const closingTagWithoutSlash = element.replace("/", "")
            if (
              incompleteHtmlTags[incompleteHtmlTags.length - 1] 
              &&
              incompleteHtmlTags[incompleteHtmlTags.length - 1] === closingTagWithoutSlash
            ) {
              incompleteHtmlTags.pop()
            }
          } else {
            const splitedCurrentTagTextArray = element.split(" ")
            const currentTagWithoutParams = splitedCurrentTagTextArray.length === 1 ? splitedCurrentTagTextArray[0] : splitedCurrentTagTextArray[0] + '>'
            incompleteHtmlTags.push(currentTagWithoutParams)
          }
        })

        if (incompleteHtmlTags[0]) {
          const closingTagOfFirstIncompleteTag = incompleteHtmlTags[0].replace("<", "</")
          const indexOfTheFirstClosingAnchorTag = restOfTheDescription.indexOf(closingTagOfFirstIncompleteTag)
          const closingTagLength = closingTagOfFirstIncompleteTag !== undefined ? closingTagOfFirstIncompleteTag.length : 0
          const actualIndexOfClosingAnchorTag = MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE + indexOfTheFirstClosingAnchorTag + closingTagLength
          return descriptionBeforeAttachingReadmore.substring(0, actualIndexOfClosingAnchorTag)
        }
      }
      return descriptionAfterAttachingReadmore  
    },
    findSubstringInstances(inputString: string, substring: any) {
      return inputString.split(substring)
    },
    togglePostCompletion() {
      this.$emit('togglePostCompletion')
    },
    expandPostDescription() {
      if (!this.expandPost) {
        document
          .querySelector('#read-more-post')
          .removeEventListener('click', this.expandPostDescription)
      }
      this.expandPost = !this.expandPost
      if (!this.expandPost) {
        setTimeout(() => {
          document
            .querySelector('#read-more-post')
            .addEventListener('click', this.expandPostDescription)
        }, 500)
      }
    },
    expandPostDetails() {
      this.expandPostData = !this.expandPostData
    },
    gotoPreviousPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.previousPostData.categoryId || this.categoryId,
          post_id: this.previousPostData.postId
        },
        query: {
          template_id: this.templateId
        }
      })
    },
    goToNextPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.nextPostData.categoryId,
          post_id: this.nextPostData.postId
        },
        query: {
          template_id: this.templateId
        }
      })
    }
  }
})
